import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

const UnAuthorized: FunctionComponent = () => {
    return (
        <>
            <Helmet>
                <title>UnAuthorized | Starjack Admin</title>
            </Helmet>
            <Box
                component='main'
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexGrow: 1,
                    minHeight: '100%',
                }}
            >
                <Container maxWidth='md'>
                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Box
                            sx={{
                                mb: 3,
                                textAlign: 'center',
                            }}
                        >
                            <img
                                alt='Under development'
                                src='/assets/errors/error-401.png'
                                style={{
                                    display: 'inline-block',
                                    maxWidth: '100%',
                                    width: 400,
                                }}
                            />
                        </Box>
                        <Typography
                            align='center'
                            sx={{ mb: 3 }}
                            variant='h3'
                            color='error'
                        >
                            Sie haben keinen Zugriff auf diese Seite
                        </Typography>
                        <Typography
                            align='center'
                            color='text.secondary'
                            variant='body1'
                        >
                            Zu dieser Seite haben Sie keinen Zugriff. Bitte
                            kontaktieren Sie ihren Administrator.
                        </Typography>
                        {/*<Button*/}
                        {/*    component={NextLink}*/}
                        {/*    href='/'*/}
                        {/*    startIcon={*/}
                        {/*        <SvgIcon fontSize='small'>*/}
                        {/*            <ArrowLeftIcon />*/}
                        {/*        </SvgIcon>*/}
                        {/*    }*/}
                        {/*    sx={{ mt: 3 }}*/}
                        {/*    color='error'*/}
                        {/*    variant='contained'*/}
                        {/*>*/}
                        {/*    */}
                        {/*</Button>*/}
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default UnAuthorized;
